function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import { Message } from 'oskari-ui';
import { StateHandler, Messaging, controllerMixin } from 'oskari-ui/util';
export var getValidationMessageKey = function getValidationMessageKey() {
  var inputQuery = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!inputQuery) {
    return;
  }
  var query = inputQuery.trim();
  var nonWildcardQuery = query.replaceAll('*', '').replaceAll('?', '');
  if (!nonWildcardQuery.length) {
    // only stars/wildcards
    return 'too_many_stars';
  }
};
var showMessage = function showMessage(key, args) {
  var defaultMsg = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : key;
  return Messaging.error(/*#__PURE__*/React.createElement(Message, {
    messageKey: key,
    messageArgs: args,
    defaultMsg: defaultMsg,
    bundleKey: "Search"
  }));
};
var UIHandler = /*#__PURE__*/function (_StateHandler) {
  function UIHandler(useAutoComplete, service, sandbox, consumer) {
    var _this;
    _classCallCheck(this, UIHandler);
    _this = _callSuper(this, UIHandler);
    _this.sandbox = sandbox;
    _this.service = service;
    _this.useAutoComplete = !!useAutoComplete;
    _this.log = Oskari.log('SearchHandler');
    _this.setState({
      query: '',
      suggestions: [],
      result: {},
      loading: false
    });
    _this.addStateListener(consumer);
    _this.eventHandlers = _this._createEventHandlers();
    return _this;
  }
  _inherits(UIHandler, _StateHandler);
  return _createClass(UIHandler, [{
    key: "triggerSearch",
    value: function triggerSearch(query) {
      this.updateState({
        query: query
      });
      if (query === '') {
        this.updateState({
          suggestions: [],
          result: {}
        });
        return;
      }
      if (!this._validateSearchKey(query)) {
        return;
      }
      this.updateState({
        loading: true,
        result: {},
        suggestions: []
      });
      this.sandbox.postRequestByName('SearchRequest', [query]);
    }
  }, {
    key: "updateQuery",
    value: function updateQuery(query) {
      var _this2 = this;
      this.updateState({
        query: query,
        suggestions: []
      });
      if (this.useAutoComplete && query.length > 1) {
        this.service.doAutocompleteSearch(query, function (result) {
          _this2.updateState({
            suggestions: result.methods
          });
        });
      }
    }
  }, {
    key: "_validateSearchKey",
    value: function _validateSearchKey(key) {
      // empty string
      if (key === null || key === undefined || key.trim().length === 0) {
        showMessage('cannot_be_empty');
        return false;
      }
      var errorMsgKey = getValidationMessageKey(key);
      if (errorMsgKey) {
        showMessage(errorMsgKey);
        return false;
      }
      return true;
    }
  }, {
    key: "handleResult",
    value: function handleResult(success, result, query) {
      this.updateState({
        loading: false,
        result: result,
        query: query,
        suggestions: []
      });
      // error handling
      if (!success) {
        var genericErrorKey = 'searchservice_search_not_found_anything_text';
        var errorKey = result ? result.responseText : null;
        showMessage(errorKey || genericErrorKey, null, genericErrorKey);
      }
    }

    /// Oskari event handling ////////////////////////////////////////////////////////////

    /**
     * "Module" name for event handling
     */
  }, {
    key: "getName",
    value: function getName() {
      return 'LayerViewTabsHandler';
    }
    /**
    * @method onEvent
    * @param {Oskari.mapframework.event.Event} event a Oskari event object
    * Event is handled forwarded to correct #eventHandlers if found or discarded if not.
    */
  }, {
    key: "onEvent",
    value: function onEvent(event) {
      var handler = this.eventHandlers[event.getName()];
      if (!handler) {
        return;
      }
      return handler.apply(this, [event]);
    }
  }, {
    key: "_createEventHandlers",
    value: function _createEventHandlers() {
      var _this3 = this;
      var handlers = {
        'SearchResultEvent': function SearchResultEvent(event) {
          var params = event.getRequestParameters();
          if (_typeof(params) === 'object') {
            params = params.searchKey;
          }
          _this3.handleResult(event.getSuccess(), event.getResult(), params);
        }
      };
      Object.getOwnPropertyNames(handlers).forEach(function (p) {
        return _this3.sandbox.registerForEventByName(_this3, p);
      });
      return handlers;
    }
  }]);
}(StateHandler);
var wrapped = controllerMixin(UIHandler, ['triggerSearch', 'updateQuery']);
export { wrapped as SearchHandler };